module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-md-1-5 pure-u-lg-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-md-3-5 pure-u-lg-1-2"
  }, [_c('div', {
    staticClass: "content box padding-30-reactive"
  }, [(_vm.active) ? _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-1-2"
  }, [_c('h3', {
    staticClass: "responsive"
  }, [_vm._v(_vm._s(_vm.step) + ". " + _vm._s(_vm.title ? _vm.title : 'Review'))])]), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 spacing-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1"
  }, [_vm._l((_vm.summary), function(text) {
    return _c('div', {
      staticClass: "summary"
    }, [_c('div', {
      staticClass: "pure-u-sm-1-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "pure-u-1 pure-u-sm-1-2 padding-bottom-10"
    }, [_vm._v(_vm._s(text))])])
  }), _vm._v(" "), (_vm.needAgree) ? _c('div', {
    staticClass: "pure-u-1 spacing-20"
  }) : _vm._e(), _vm._v(" "), (_vm.needAgree) ? _c('div', {
    staticClass: "pure-u-1-24 pure-u-sm-1-4 text-right-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreed),
      expression: "agreed"
    }],
    attrs: {
      "id": "agree",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreed) ? _vm._i(_vm.agreed, null) > -1 : (_vm.agreed)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreed = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.needAgree) ? _c('div', {
    staticClass: "pure-u-11-12 pure-u-sm-1-2 summary"
  }, [_c('label', {
    staticClass: "pure-checkbox",
    attrs: {
      "for": "agree"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.agreement)
    }
  }), _vm._v(" "), (_vm.error && !_vm.agreed) ? _c('div', {
    staticClass: "text-red"
  }, [_vm._v("Must check box to agree.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1 pure-u-sm-1-2"
  }, [_c('button', {
    staticClass: "pure-button pure-button-primary block padding-10 margin-10 margin-left-0",
    on: {
      "click": _vm.success
    }
  }, [_vm._v("\n              " + _vm._s(_vm.buttonText) + "\n            ")])])], 2)]) : _c('div', {
    staticClass: "pure-u-1"
  }, [_c('h3', {
    staticClass: "responsive"
  }, [_vm._v(_vm._s(_vm.step) + ". " + _vm._s(_vm.title ? _vm.title : 'Review'))]), _vm._v(" "), (_vm.canEdit && !_vm.active) ? _c('button', {
    staticClass: "link-lookalike",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Review")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71733cd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/review/Review.vue
// module id = 395
// module chunks = 1